'use strict';

(function () {
	'use strict';

	baseService.$inject = ['$http', '$q', 'appConfig'];
	angular.module('app.services').factory('baseService', baseService);

	function baseService($http, $q, appConfig) {
		'ngInject';

		var service = {
			getColumnRange: getColumnRange,
			getColumnMinOrMaxValue: getColumnMinOrMaxValue,
			createDateAttrTransformer: createDateAttrTransformer,
			createDateRangeTransformer: createDateRangeTransformer,
			fillInMissingEntries: fillInMissingEntries
		};

		return service;

		////////////////

		/**
   * 
   * @param {string} path 
   * @param {string} column 
   * @param {array} extraParams 
   */
		function getColumnRange(path, column, extraParams) {
			return $q.all({
				min: getColumnMinOrMaxValue(path, column, true, extraParams),
				max: getColumnMinOrMaxValue(path, column, false, extraParams)
			});
		}

		/**
   * 
   * @param {string} path 
   * @param {string} column 
   * @param {boolean} min 
   * @param {array} extraParams 
   */
		function getColumnMinOrMaxValue(path, column, min) {
			var extraParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

			var params;

			/* Merge default parameters with extraParams */
			params = _.assign({
				select: column,
				order: min ? column + '.asc' : column + '.desc',
				limit: 1
			}, extraParams);

			return $http.get(appConfig.apiUrl + '/' + path, { params: params, cache: true }).then(function (response) {
				return response.data.length == 1 ? response.data[0] : null;
			});
		}

		/**
   * 
   * @param {string} dateColumn 
   */
		function createDateAttrTransformer(dateColumn) {
			return function (data, headersGetter, status) {
				if (status === 200) {
					if (Array.isArray(data)) {
						data.forEach(function (o) {
							o[dateColumn] = new Date(o[dateColumn]);
						});
					}
				}
				return data;
			};
		}

		function createDateRangeTransformer(fromColumn, toColumn) {
			var meanAttribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'at';

			return function (data, headersGetter, status) {
				if (status === 200) {
					if (Array.isArray(data)) {
						data.forEach(function (o) {
							var diff = moment(o[toColumn]).diff(moment(o[fromColumn]), 'seconds');
							o[fromColumn] = new Date(o[fromColumn]);
							o[toColumn] = new Date(o[toColumn]);
							o[meanAttribute] = moment(o[fromColumn]).add(diff / 2, 'seconds').toDate();
						});
					}
				}
				return data;
			};
		}

		/**
   * 
   * @param {*} entries 
   * @param {*} from 
   * @param {*} to 
   * @param {*} step 
   * @param {*} granularity 
   * @param {*} mapper 
   * @param {*} creator 
   */
		function fillInMissingEntries(entries, from, to, step, granularity, mapper, creator) {
			var now = from.clone(),
			    oldEntries = _.keyBy(entries, mapper),
			    newEntries = [],
			    previous = undefined;

			oldEntries = _(entries).keyBy(mapper);

			while (now.isBefore(to)) {
				var newEntry,
				    date = now.toDate();

				newEntry = oldEntries.get(date.toString(), creator(date, previous));
				newEntries.push(newEntry);

				now.add(step, granularity);

				previous = newEntry;
			}

			return newEntries;
		}
	}
})();